import { IActionFieldInfo, IAuditOnsiteFieldInfo } from "../../../../interfaces";

export const getSingleCategoryArrayHandler = (fields: IAuditOnsiteFieldInfo[], categoryName: string): IAuditOnsiteFieldInfo[] =>
  fields.filter(el => el.category === categoryName);

export const getSingleActionCategoryArrayHandler = (fields: IActionFieldInfo[], categoryName: string): IActionFieldInfo[] =>
  fields.filter(el => el.category === categoryName);